import React from 'react';

interface IProps {
  classes: string;
  buttonText: string;
  onClick: (event) => void;
}

export default class CreditCardFormToggleButton extends React.Component<IProps, null> {
  render() {
    return (
      (<button
        className={this.props.classes}
        onClick={this.props.onClick}
        type="button"
      >
        {this.props.buttonText}
      </button>)
    );
  }
}
